import { Component } from '@angular/core';

@Component({
    selector: 'app-resources-status',
    templateUrl: './resources-status.component.html',
    styleUrl: './resources-status.component.css',
    standalone: false
})
export class ResourcesStatusComponent {

}
